import React from 'react'

import { Container, Header, Image } from "semantic-ui-react";
const NoSummaryData = (props) => (
    <Container fluid style={{ padding: "50px 0" }}  >
        <div style={{ padding: "30px", background: "#607d8b", borderRadius: "500em", width: "140px", height: "140px", margin: "0 auto" }}>
            <Image
                style={{ width: "80px" }}
                src={props.imageName}
                className="landingImage"
                centered={true} />
        </div>
        <Header
            as='h6'
            icon
            textAlign='center' >
            <Header.Content>
                No {props.type} To show !
        </Header.Content>
        </Header>
    </Container>
)

export default NoSummaryData